import { FunctionComponent, lazy } from 'react'
import { Navigate } from 'react-router-dom'
import { useDxpPreviewParam, usePlatformConfig } from '@dxp-module/common'
import ROUTES from '../common/enum/Routes'

const SignUpContainer = lazy(() => import('./SignUpContainer'))

const SignUpLazyContainer: FunctionComponent = () => {
  const {
    platformConfig: {
      myAccount: { isSeparateSignupLogin },
    },
  } = usePlatformConfig()
  const previewSearchParam = useDxpPreviewParam()

  return isSeparateSignupLogin ? (
    <SignUpContainer />
  ) : (
    <Navigate
      to={`${ROUTES.INDEX}${
        previewSearchParam ? `?${previewSearchParam}` : ''
      }`}
    />
  )
}

export default SignUpLazyContainer
